import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Campaign } from '../../../types/campaigns.models';
import {
  CampaignCardComponent,
  CampaignCardVM,
} from '../../shared/campaign/card/card.component';

type CampaignVM = Campaign & {
  currentAmount: number;
  progressPct: number;
  selected: boolean;
};

@Component({
    selector: 'don-campaigns-list',
    imports: [CommonModule, CampaignCardComponent],
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.css']
})
export class CampaignsListComponent implements OnChanges {
  /** Entradas puras (sin Store) */
  @Input() campaigns: Campaign[] | null = [];
  @Input() selectedId: string | null = null;

  /** Evento hacia el padre */
  @Output() select = new EventEmitter<string>();

  /** VM derivada para pintar */
  vms: CampaignVM[] = [];

  ngOnChanges(_changes: SimpleChanges): void {
    const list = this.campaigns ?? [];
    const selectedId = this.selectedId ?? null;

    this.vms = list.map<CampaignVM>((c) => {
      const currentAmount =
        (c as any).raisedAmount ?? (c as any).currentAmount ?? 0;
      const progressPct =
        c.targetAmount > 0
          ? Math.max(0, Math.min(100, (currentAmount / c.targetAmount) * 100))
          : 0;

      return {
        ...c,
        currentAmount,
        progressPct,
        selected: c.id === selectedId,
      };
    });
  }

  trackById = (_: number, c: CampaignVM) => c.id;

  /** Reemite hacia el padre */
  onSelect(id: string) {
    this.select.emit(id);
  }

  // helper para castear al tipo del card (sin cambiar tu Card)
  toCardVM(c: CampaignVM): CampaignCardVM {
    return c as unknown as CampaignCardVM;
  }
}
